export const WhyChooseUsTableColumns = (isArabic) => [
    { id: 'title', label: isArabic ? 'العنوان' : 'Title', align: 'start' },
    { id: 'sort_order', label: isArabic ? 'الترتيب' : 'Sort Order', align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' },
];
